var api = require("!../../node_modules/_style-loader@1.3.0@style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/_extract-text-webpack-plugin@3.0.2@extract-text-webpack-plugin/dist/loader.js??ref--7-0!../../node_modules/_vue-style-loader@3.1.2@vue-style-loader/index.js!../../node_modules/_css-loader@0.28.11@css-loader/index.js??ref--7-2!../../node_modules/_postcss-loader@2.1.6@postcss-loader/lib/index.js??ref--7-3!./base.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};


//////////////////
// WEBPACK FOOTER
// ./src/common/base.css
// module id = IAVT
// module chunks = 12